import React, { ReactNode, useEffect, useState } from 'react'
import Sidebar from '../Sidebar'
import Header from '../Header/Header'
import { Box } from '@mui/material'
import { useGlobalContext } from '@/context/GlobalContext'
import { useLocation } from 'react-router'
import OrganisationSidebar from '../Sidebar/OrganisationSidebar'

interface MainLayoutProps {
  showSidebar: boolean
  children: ReactNode
  showHeader?: boolean
}

const MainLayout: React.FC<MainLayoutProps> = React.memo(
  ({ showSidebar, children, showHeader = true }) => {
    const { viewMode } = useGlobalContext()
    const [isSidebarShown, setSidebarShown] = useState(false)
    const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
      return (
        localStorage.getItem('isCollapsed') === 'true' ||
        viewMode === 'embedded'
      )
    })
    const location = useLocation()

    useEffect(() => {
      // const initValue = localStorage.getItem('isCollapsed')
      // console.log('🚀 ~ useEffect ~ initValue:', initValue)
      // if (initValue !== null) {
      // }
      localStorage.setItem('isCollapsed', JSON.stringify(isCollapsed))
    }, [isCollapsed])

    return (
      <Box sx={{ display: '-webkit-box', position: 'relative' }}>
        {showSidebar && (
          <Box sx={{ position: 'relative', zIndex: 1100 }}>
            {location.pathname &&
            location.pathname.startsWith('/organisation') ? (
              <OrganisationSidebar
                isCollapsed={isCollapsed}
                toggleCollapse={() => setIsCollapsed(!isCollapsed)}
              />
            ) : (
              <Sidebar
                isCollapsed={isCollapsed}
                toggleCollapse={() => setIsCollapsed(!isCollapsed)}
              />
            )}
          </Box>
        )}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            width: '100%',
            ml: showSidebar ? (isCollapsed ? '70px' : '200px') : 0,
            transition: theme =>
              theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
              }),
            position: 'relative',
            zIndex: 1000, // Lower than the sidebar
          }}
        >
          {showHeader && (
            <Header onToggleSidebar={() => setSidebarShown(!isSidebarShown)} />
          )}
          <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>{children}</Box>
        </Box>
      </Box>
    )
  },
)

export default MainLayout
